<template>
	<div
		class="exhibition-block panel panel-default sidebar-menu wow fadeInLeft animated"
		style="visibility: visible;">
		<div class="panel-heading">
			<h3 class="panel-title">{{ exhibition.name }}</h3>
		</div>
		<div class="panel-body text-widget">
			<ul class="list-unstyled">
				<li>
					<i class="fa fa-calendar" aria-hidden="true"></i> {{ $filters.formatDate(exhibition.from) }} - {{ $filters.formatDate(exhibition.till) }}
				</li>
				<li>
					<i class="fa fa-map-marker" aria-hidden="true"></i> <b>{{ exhibition.place }}</b>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	exhibition: {
		type: Object,
		required: true
	}
})
</script>
